import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, TypeOf, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import {useLocation} from "react-router";

import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";



import TimberTypeFormSelect from "../../../../timber/components/timberType/TimberTypeForm/TimberTypeFormSelect";
import { PrimaryTimberType } from "../../../../timber/types/models/TimberType.ts";

import TimberClassFormSelect from "../../../../timber/components/timberClass/TimberClassForm/TimberClassFormSelect";
import { PrimaryTimberClass } from "../../../../timber/types/models/TimberClass.ts";

import ShipmentFormSelect from "../../../../timber/components/shipment/ShipmentForm/ShipmentFormSelect";
import { PrimaryShipment } from "../../../../timber/types/models/Shipment.ts";
import { PrimaryTimberStorage } from "../../../../timber/types/models/TimberStorage.ts";
import { useGetTimberStorageQuery } from "../../../../timber/apis/TimberStorage.api";
import { useGetCuttingQuery } from "../../../../timber/apis/Cutting.api";
import { PrimaryCutting } from "../../../../timber/types/models/Cutting.ts";
import { t, msg } from "@lingui/core/macro"


















const ShipmentFormSelect_shipmentId = ({watch, prefix = ''})  => {

    const [storageId,] = watch([
        'storageId',
    ])


    const { data: storage } = useGetTimberStorageQuery(
        PrimaryTimberStorage.fromId(storageId),
        { skip: !storageId }
    )

    const { data: cutting } = useGetCuttingQuery(
        storage?.cuttingId ? PrimaryCutting.fromId(storage.cuttingId) : PrimaryCutting.fromId(undefined),
        { skip: !storage?.cuttingId }
    )

    const allowsMultiStorage = cutting?.allowsMultiStorageShipments === true

    const filter = allowsMultiStorage
        ? { cuttingIdRefs: storage?.cuttingId ? [storage.cuttingId] : [] }
        : { storageIdRefs: storageId ? [storageId] : [] }

    return (
    <ShipmentFormSelect
        type="dynamicSelect"
        name="shipmentId"
        label={t`Shipment`}
        prefix={prefix}
        required={ false }

        filter={ filter }

    />
    )
}







export const initialFormStateFn = () => { return {
    
        
        volume: "",
        
    
        
        measurementType: CordwoodMeasurementType.m3,
        
    
        
        timberTypeId: null,
        
    
        
        classId: null,
        
    
        
        commited: false,
        
    
        
        shipmentId: null,
        
    
        
        localUpdatedAt: formatDateTimeParam(new Date()),
        
    
        
        localDeletedAt: formatDateTimeParam(new Date()),
        
    
        
        description: "",
        
    
} }

export const useLocationFormState = (oldState) => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    

    return initialFormState
}

export const formObject = {
    
    
        volume:
        number()
                     .gt(0).transform((value) => (!value ? null : value))
                    .and(coerce.number(msg`must be a number.`)),
    
    
        measurementType:
        string()
        .trim()
        .min(1, msg`MU is required`),
    
    
        timberTypeId:
        string()
                .nanoid(msg`Timber Type is required`)
                .min(1, msg`Timber Type is required`),
    
    
        classId:
        string()
                .nanoid(msg`Timber Class is required`)
                .min(1, msg`Timber Class is required`),
    
    
        commited:
        boolean()
        ,
    
    
        shipmentId:
        string()
                .nanoid(msg`Shipment is required`)
                .nullish(),
    
    
        localUpdatedAt:
        string()
        .trim()
        .nullish(),
    
    
        localDeletedAt:
        string()
        .trim()
        .nullish(),
    
    
        description:
        string()
        .trim()
        .nullish(),
    
};

export const formSchema = object(formObject);

const CordwoodUpdateForm = ({watch, prefix = ''})  => {
    return (
        <Container>
            
            
   
   <crudgen.FormInput
       required
       name={ prefix + 'volume' }
       aria-label="volume"
       data-testid="volume"
       label={t`Volume`}
       
       type='number'
       checkNumber={true}
       forceNumber={true}
       
   />
   
   
            
            
   
    <crudgen.FormSelect
        required
        name={ prefix + 'measurementType' }
        aria-label="measurementType"
        label={t`MU`}
        options={ CordwoodMeasurementTypePairs }
        optionLabelMap={ toStringCordwoodMeasurementType }
    />
   
   
            
            
   
    
    <TimberTypeFormSelect
        type="select"
        name="timberTypeId"
        label={t`Timber Type`}
        prefix={prefix}
        required={ true }
    />
   
   
   
            
            
   
    
    <TimberClassFormSelect
        type="select"
        name="classId"
        label={t`Timber Class`}
        prefix={prefix}
        required={ true }
    />
   
   
   
            
            
   
   <crudgen.FormCheckbox
       required
       name={ prefix + 'commited' }
       aria-label="commited"
       data-testid="commited"

       label={t`Commited`}
   />
   
   
            
            
   
    
    <ShipmentFormSelect_shipmentId
        watch={watch}
        prefix={prefix}
    />
   
   
   
            
            
   
        
           <crudgen.FormDateTime
                
                name={ prefix + 'localUpdatedAt' }
                aria-label="localUpdatedAt"
                label={t`Local Updated At`}
           />
       
   
   
            
            
   
        
           <crudgen.FormDateTime
                
                name={ prefix + 'localDeletedAt' }
                aria-label="localDeletedAt"
                label={t`Local Deleted At`}
           />
       
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'description' }
       aria-label="description"
       data-testid="description"
       label={t`Description`}
       
       type='text'
       
   />
   
   
            
        </Container>
    )
}

export default CordwoodUpdateForm;
